import type { RouteRecordRaw } from 'vue-router';

export const registryRoutes: RouteRecordRaw[] = [
  {
    path: 'registry',
    name: 'registry',
    component: () => import('./pages/RegistrySearchPage.vue'),
    meta: { title: 'Business Registry', requiresAuth: true, permission: 'view_customers' },
  },
];
